export const sekki = [
  {year: 2024, month: 1, day: 6, name: '二十四節気／小寒'},
  {year: 2024, month: 1, day: 20, name: '二十四節気／大寒'},
  {year: 2024, month: 2, day: 3, name: '雑節／節分'},
  {year: 2024, month: 2, day: 4, name: '二十四節気／立春'},
  {year: 2024, month: 2, day: 19, name: '二十四節気／雨水'},
  {year: 2024, month: 3, day: 5, name: '二十四節気／啓蟄'},
  {year: 2024, month: 3, day: 17, name: '雑節／彼岸の入り'},
  {year: 2024, month: 3, day: 20, name: '二十四節気／春分'},
  {year: 2024, month: 3, day: 25, name: '雑節／社日（春）'},
  {year: 2024, month: 4, day: 4, name: '二十四節気／清明'},
  {year: 2024, month: 4, day: 19, name: '二十四節気／穀雨'},
  {year: 2024, month: 5, day: 1, name: '雑節／八十八夜'},
  {year: 2024, month: 5, day: 5, name: '二十四節気／立夏'},
  {year: 2024, month: 5, day: 20, name: '二十四節気／小満'},
  {year: 2024, month: 6, day: 6, name: '二十四節気／芒種'},
  {year: 2024, month: 6, day: 10, name: '雑節／入梅'},
  {year: 2024, month: 6, day: 21, name: '二十四節気／夏至'},
  {year: 2024, month: 7, day: 1, name: '雑節／半夏生'},
  {year: 2024, month: 7, day: 6, name: '二十四節気／小暑'},
  {year: 2024, month: 7, day: 20, name: '雑節／夏土用入り'},
  {year: 2024, month: 7, day: 22, name: '二十四節気／大暑'},
  {year: 2024, month: 8, day: 7, name: '二十四節気／立秋'},
  {year: 2024, month: 8, day: 22, name: '二十四節気／処暑'},
  {year: 2024, month: 8, day: 31, name: '雑節／二百十日'},
  {year: 2024, month: 9, day: 7, name: '二十四節気／白露'},
  {year: 2024, month: 9, day: 10, name: '雑節／二百二十日'},
  {year: 2024, month: 9, day: 19, name: '雑節／秋彼岸入'},
  {year: 2024, month: 9, day: 21, name: '雑節／社日（秋）'},
  {year: 2024, month: 9, day: 22, name: '二十四節気／秋分'},
  {year: 2024, month: 10, day: 8, name: '二十四節気／寒露'},
  {year: 2024, month: 10, day: 23, name: '二十四節気／霜降'},
  {year: 2024, month: 11, day: 7, name: '二十四節気／立冬'},
  {year: 2024, month: 11, day: 22, name: '二十四節気／小雪'},
  {year: 2024, month: 12, day: 7, name: '二十四節気／大雪'},
  {year: 2024, month: 12, day: 21, name: '二十四節気／冬至'},
  {year: 2025, month: 1, day: 5, name: '二十四節気／小寒'},
  {year: 2025, month: 1, day: 20, name: '二十四節気／大寒'},
  {year: 2025, month: 2, day: 2, name: '雑節／節分'},
  {year: 2025, month: 2, day: 3, name: '二十四節気／立春'},
  {year: 2025, month: 2, day: 18, name: '二十四節気／雨水'},
  {year: 2025, month: 3, day: 5, name: '二十四節気／啓蟄'},
  {year: 2025, month: 3, day: 17, name: '雑節／彼岸の入り'},
  {year: 2025, month: 4, day: 4, name: '二十四節気／清明'},
  {year: 2025, month: 4, day: 20, name: '二十四節気／穀雨'},
  {year: 2025, month: 5, day: 1, name: '雑節／八十八夜'},
  {year: 2025, month: 5, day: 5, name: '二十四節気／立夏'},
  {year: 2025, month: 5, day: 21, name: '二十四節気／小満'},
  {year: 2025, month: 6, day: 5, name: '二十四節気／芒種'},
  {year: 2025, month: 6, day: 11, name: '雑節／入梅'},
  {year: 2025, month: 6, day: 21, name: '二十四節気／夏至'},
  {year: 2025, month: 7, day: 1, name: '雑節／半夏生'},
  {year: 2025, month: 7, day: 7, name: '二十四節気／小暑'},
  {year: 2025, month: 7, day: 19, name: '雑節／夏土用入り'},
  {year: 2025, month: 7, day: 22, name: '二十四節気／大暑'},
  {year: 2025, month: 8, day: 7, name: '二十四節気／立秋'},
  {year: 2025, month: 8, day: 23, name: '二十四節気／処暑'},
  {year: 2025, month: 8, day: 31, name: '雑節／二百十日'},
  {year: 2025, month: 9, day: 7, name: '二十四節気／白露'},
  {year: 2025, month: 9, day: 10, name: '雑節／二百二十日'},
  {year: 2025, month: 9, day: 20, name: '雑節／秋彼岸入'},
  {year: 2025, month: 9, day: 23, name: '二十四節気／秋分'},
  {year: 2025, month: 9, day: 26, name: '雑節／社日（秋）'},
  {year: 2025, month: 10, day: 8, name: '二十四節気／寒露'},
  {year: 2025, month: 10, day: 23, name: '二十四節気／霜降'},
  {year: 2025, month: 11, day: 7, name: '二十四節気／立冬'},
  {year: 2025, month: 11, day: 22, name: '二十四節気／小雪'},
  {year: 2025, month: 12, day: 7, name: '二十四節気／大雪'},
  {year: 2025, month: 12, day: 22, name: '二十四節気／冬至'},
  {year: 2026, month: 1, day: 5, name: '二十四節気／小寒'},
  {year: 2026, month: 1, day: 20, name: '二十四節気／大寒'},
  {year: 2026, month: 2, day: 3, name: '雑節／節分'},
  {year: 2026, month: 2, day: 4, name: '二十四節気／立春'},
  {year: 2026, month: 2, day: 19, name: '二十四節気／雨水'},
  {year: 2026, month: 3, day: 5, name: '二十四節気／啓蟄'},
  {year: 2026, month: 3, day: 17, name: '雑節／彼岸の入り'},
  {year: 2026, month: 3, day: 20, name: '国民の祝日／春分の日　二十四節気／春分'},
]
